import { useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useBackupDownload = () => {
  const httpClient = useHttpClient(true, true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadBackup = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await httpClient.current?.get('/api/admin/backup/download');
      const blob = response.data;
      const disposition = response.headers['content-disposition'] ?? '';
      const name = disposition.split('filename=')[1]?.replace(/"/g, '').trim()
        || `agrised-backup-${new Date().toISOString().split('T')[0]}.xlsx`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      setError('La génération de la sauvegarde a échoué. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return { downloadBackup, loading, error };
};
